module.exports = __webpack_public_path__ + "img/overview-scene-bg.14e71c1e.jpg";